import React from 'react';
import { IShipWindow } from '../../../types/IFilterEngine';
import { formatDateByMonthDay } from '../../PreOrders/Utils';
import '../index.scss';

interface IShipWindowToggleBar {
  shipWindows: IShipWindow[];
  selectedShipWindows: string[];
  setSelectedShipWindows: (selectedShipWindows: string[]) => void;
  title?: string;
  className?: string;
}

/**
 * Ship windows as one row of toggles, all of them or a single window at a time.
 * Spread the props of useShipDateFilter into it, the state lives in the hook.
 */
const ShipWindowToggleBar = ({
  shipWindows,
  selectedShipWindows,
  setSelectedShipWindows,
  title = 'You have offers across multiple ship dates:',
  className = '',
}: IShipWindowToggleBar) => {
  if (shipWindows.length < 2) return null;

  const isAllSelected = selectedShipWindows.length === 0;

  return (
    <div className={`cell small-12 margin-bottom-1 px-ship-window-toggle ${className}`}>
      <div className="margin-bottom-1">{title}</div>
      <div>
        <button
          type="button"
          className={`px-ship-window-option${isAllSelected ? ' active' : ''}`}
          aria-pressed={isAllSelected}
          onClick={() => setSelectedShipWindows([])}>
          All
        </button>
        {shipWindows.map((shipWindow: IShipWindow) => {
          const isSelected = selectedShipWindows.includes(shipWindow.key);
          return (
            <button
              key={shipWindow.key}
              type="button"
              className={`px-ship-window-option${isSelected ? ' active' : ''}`}
              aria-pressed={isSelected}
              onClick={() => setSelectedShipWindows([shipWindow.key])}>
              {formatDateByMonthDay(shipWindow.shippingStartDate, shipWindow.shippingEndDate)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ShipWindowToggleBar;
